import { ComponentInfoChatVO, ComponentInfoLoadChatsVO } from '@repo/types'
import { fetcher } from '../utils'

export default async (input: ComponentInfoLoadChatsVO, cursor: number = 0): Promise<ComponentInfoChatVO[]> => {
  return fetcher(`/api/componentInfo/chats?cursor=${cursor}&offset=25`, 'POST', input)
}
